import { PlayerConfig } from "../../Config";
import { ILaya } from "../../ILaya";
import { Laya } from "../../Laya";
import { LayaEnv } from "../../LayaEnv";
import { Loader } from "../net/Loader";
import { GRoot } from "./GRoot";
import { UIConfig2 } from "./UIConfig";
export class UIPackage {
    static createButton() {
        return Loader.createNodes("internal/UI/Button.lh");
    }
    static createRadio() {
        return Loader.createNodes("internal/UI/Radio.lh");
    }
    static createCheckBox() {
        return Loader.createNodes("internal/UI/CheckBox.lh");
    }
    static createProgressBar() {
        return Loader.createNodes("internal/UI/ProgressBar.lh");
    }
    static createSliderH() {
        return Loader.createNodes("internal/UI/SliderH.lh");
    }
    static createSliderV() {
        return Loader.createNodes("internal/UI/SliderV.lh");
    }
    static createTextInput() {
        return Loader.createNodes("internal/UI/TextInput.lh");
    }
    static createTextArea() {
        return Loader.createNodes("internal/UI/TextArea.lh");
    }
    static createComboBox() {
        return Loader.createNodes("internal/UI/ComboBox.lh");
    }
    static _init() {
        if (!LayaEnv.isPlaying)
            return null;
        GRoot.inst;
        const urls = [
            UIConfig2.windowModalWaiting,
            UIConfig2.globalModalWaiting,
            UIConfig2.popupMenu,
            UIConfig2.tooltipsWidget,
            UIConfig2.horizontalScrollBar,
            UIConfig2.verticalScrollBar
        ].filter((url) => url != null);
        if (PlayerConfig.UI.alwaysIncludeDefaultSkin) {
            urls.push(...[
                "Button.lh",
                "Radio.lh",
                "CheckBox.lh",
                "ProgressBar.lh",
                "SliderH.lh",
                "SliderV.lh",
                "TextInput.lh",
                "TextArea.lh",
                "ComboBox.lh"
            ].map((url) => "internal/UI/" + url));
        }
        return ILaya.loader.load(urls);
    }
}
Laya.addAfterInitCallback(UIPackage._init);
